import { render, staticRenderFns } from "./LeadBoxMultiple.vue?vue&type=template&id=5bf39f68&scoped=true&"
import script from "./LeadBoxMultiple.vue?vue&type=script&lang=js&"
export * from "./LeadBoxMultiple.vue?vue&type=script&lang=js&"
import style0 from "./LeadBoxMultiple.vue?vue&type=style&index=0&id=5bf39f68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf39f68",
  null
  
)

export default component.exports